import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import { getUserDetails } from '../../Utility/UserUtility';
import Spinner from '../Spinner/Spinner';
import $, { event } from "jquery";
import { AddUpdateCart, GetCart } from '../../Utility/CartUtility';
import { buffer } from "stream/consumers";
import { useNavigate } from 'react-router-dom';


const PaymentResponse_PayU = () => {

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [PaymentStatus, setPaymentStatus] = useState(true);

  useEffect(() => {
    
    // Get payment response data from URL parameters
    const queryParams = new URLSearchParams(window.location.search);
    const OrderId: any = queryParams.get('OID')?.replace("Test_","");
    const Status : any = queryParams.get('ST');

    ValidatePayment(OrderId,Status);
  }, []);


  const ValidatePayment = (_OrderId: any, _Status: any) => {
    setIsLoading(true);

    if (_Status === "S") {
      apiGet('api/PlaceOrder/OrderPaymentValidatePayU?OrderId='+ _OrderId).then((res: any) => {
        
        setIsLoading(false);
        if (res?.Data !== null) {
          setPaymentStatus(res?.Data?.Status);
          if (res.Data.Status) {
            navigate('/OrderResponse/' + _OrderId);
          }
        }
      });
    }
    else{
      setPaymentStatus(false);
      setIsLoading(false);
    }

  }



  return (<>

    {(isLoading && <Spinner></Spinner>)}
    <br></br>
    <br></br>
    <br></br>
    <div className=" breadcrumb-padding-180"></div>

    {PaymentStatus === false && <div className="alert alert-danger">
      Fatal Error Occured while Processing your Order.Please Try Again Later. If any Amount is Deducted then <a href="/contactus" className="alert-link">contact us </a>.
    </div>}

    <br></br>
    <br></br>

  </>);
}

export default PaymentResponse_PayU;
